import React, { useState } from 'react';

import AboutBox from '../../components/AboutBox/AboutBox';

import classes from './About.module.scss';

const About = () => {
    const [active, setActive] = useState(null);

    return <div className={classes.Right}>
        <h1>About</h1>
        <AboutBox type="plenary" active={active} onSelect={setActive} />
        <AboutBox type="scientific" active={active} onSelect={setActive} />
        <AboutBox type="section" active={active} onSelect={setActive} />
        <AboutBox type="organizer" active={active} onSelect={setActive} />
    </div>
}

export default About;